import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {SvgIconRegistryService} from "angular-svg-icon";
import {Subscription} from "rxjs";

require('./bringoz-icon.scss');
@Component({
  standalone: false,
  selector: 'bringoz-icon',
  templateUrl: './bringoz-icon.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozIconComponent implements OnInit, OnChanges {

  @Input() iconName: string;
  @Input() fill: string;
  @Input() color?: string;
  @Input() tooltip?: string;
  @Input() size?: number;
  @Input() classSize?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' = 'lg';
  public loaded: boolean = false;

  public height?: string;
  public width?: string;

  private getIconSubscription: Subscription;
  private loadIconSubscription: Subscription;

  constructor(@Inject(SvgIconRegistryService) private iconReg: SvgIconRegistryService, @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this._setIcon();

    if (this.color) {
      this._setFillByColor();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.iconName && this.iconName) {
      this._setIcon();
    }
    if (changes.size && this.size) {
      this.height = `${this.size}px`;
      this.width = `${this.size}px`;
    }
  }

  $onDestroy() {
    if (this.getIconSubscription) {
      this.getIconSubscription.unsubscribe();
    }
    if (this.loadIconSubscription) {
      this.loadIconSubscription.unsubscribe();
    }
  }

  private _setIcon() {
    this.loaded = false;
    if (this.iconName) {
      this.getIconSubscription = this.iconReg.getSvgByName(this.iconName).subscribe({
        next: (x) => {
          this.loaded = true;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this._loadIcon();
        }
      });
    }
  }

  private _loadIcon() {
    this.loadIconSubscription = this.iconReg.loadSvg(`/assets/images/icons/v2/${this.iconName}.svg`, this.iconName)
      .subscribe((res) => {
        this.loaded = true;
        this.cdr.detectChanges();
      });
  }

  private _setFillByColor() {
    // Consider moving this to a service and use only getCssVariable in this component.
    const getCSSVariable = (variable: string) =>
      getComputedStyle(document.documentElement).getPropertyValue(variable).trim();

    this.fill = getCSSVariable(`--${this.color}`);
    this.cdr.detectChanges();
  }

}
